const FACEBOOK_AUTH_STATUSES = {
    unauthorized: 'unauthorized',
    reredirect: 'reredirect',
    completed: 'completed',
}

export {
    FACEBOOK_AUTH_STATUSES,
}
